module.exports = __webpack_public_path__ + "img/cooperation.872f4c95.png";